import React from "react";
import ParkEnter from "../../ParkEnter";

const Screen16 = () => {
    return <ParkEnter />;
};

export default Screen16;
